export default "__VITE_ASSET__$w7zr9t0__"